import styled from 'styled-components';

import { Text } from '../../../../components';
import { contentAreaOverlay } from '../../../../theme/contentAreaOverlay';
import { AFFILIATE_FORM, COLORS, MOBILE } from '../../../../theme/tokens';

/**
 * Compact confirmation dialog — the same treatment as the acquisition ad-budgets /
 * top-up confirm (`AdBudgetLimit` `.abl-confirm`): a centred card over a dimmed,
 * blurred backdrop. Portalled to <body> and re-pinned to the MainLayout content
 * card on desktop (so it centres over the card, not the off-centre viewport).
 */
export const Backdrop = styled.div`
  position: fixed;
  inset: 0;
  z-index: 2200;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: ${COLORS.modalScrim};
  backdrop-filter: blur(2px);
  ${contentAreaOverlay}
`;

export const CardBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  /* Wide enough that the side-by-side CTAs keep their labels on a single line
     (e.g. "Discard website"). */
  max-width: 440px;
  padding: 20px;
  border-radius: 16px;
  background: ${AFFILIATE_FORM.surface};
  border: 1px solid ${COLORS.panelBorder};
  /* Same large soft modal shadow as the Overlay component so the card lifts off
     the dimmed backdrop consistently with the rest of the studio's modals. */
  box-shadow: ${AFFILIATE_FORM.modalShadow};
`;

export const DialogTitle = styled(Text)`
  font-size: 16px;
  font-weight: 700;
  color: ${COLORS.textBrightest};
`;

export const Message = styled(Text)`
  margin: 0;
  font-size: 13px;
  font-weight: 400;
  line-height: 1.4;
  color: ${COLORS.featureName};
`;

/** Secondary note under the message (e.g. "you can start a new brand anytime"). */
export const Note = styled(Text)`
  margin: 0;
  padding: 10px 12px;
  border-radius: 12px;
  background: ${COLORS.surfaceInset};
  font-size: 12px;
  font-weight: 400;
  line-height: 1.4;
  color: ${COLORS.textSubtle};
`;

export const Actions = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;

  /* The two shared <Button>s split the row evenly; keep each label on one line. */
  > button {
    flex: 1 1 0;
    white-space: nowrap;
  }

  ${MOBILE} {
    flex-direction: column-reverse;
  }
`;
